const KEY = 'claimform_landing_query'

// The query of the page the visitor came with (the claim link, utm, gclid ...). The url is changed by the form,
// so it is kept here and sent with the claim: the server session that holds the same data can be lost.
export function captureLandingQuery() {
  try {
    if (window.location.search && !sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, window.location.search.replace(/^\?/, ''))
    }
  } catch {
    // ignore storage errors (e.g. private mode)
  }
}

export function getLandingQuery() {
  try {
    return sessionStorage.getItem(KEY) || null
  } catch {
    return null
  }
}
